export default "__VITE_ASSET__95f27393__"